import React from 'react';
import Modal from '@alfa-retail-react/components/modal';
import Button from '@alfa-retail-react/components/button';
import Link from '@alfa-retail-react/components/link';

import { useIsDesktop } from 'app/utils/useWindowType';

export interface MessageNotComingProps {
    onModalOpen?: () => void;
}

const TITLE = 'Не приходит сообщение?';

const Phone = (props: {
    phoneNumber: string;
    text: string;
}): React.ReactElement => {
    return (
        <>
            <Link view="default" href={`tel:${props.phoneNumber}`}>
                {props.phoneNumber}
            </Link>{' '}
            — {props.text}
        </>
    );
};

const getContent = (): React.ReactElement => {
    const phoneNumbers = [
        <Phone phoneNumber={'198'} text="единый номер по Беларуси" />,
        <Phone
            phoneNumber={'733-33-32'}
            text="для операторов A1, МТС, life:)"
        />,
    ];

    return (
        <>
            <div className={'infoCenterText'}>
                Если у вас сменился номер телефона, пожалуйста, обратитесь по
                телефонам контакт-центра:
            </div>
            <ul className={'phoneNumbers'}>
                {phoneNumbers.map((value, index) => {
                    return <li key={index}>{value}</li>;
                })}
            </ul>
        </>
    );
};

/**
 * Компонент "Не приходит сообщение".
 */
export const MessageNotComing = ({ onModalOpen }: MessageNotComingProps) => {
    const [isOpenModal, setIsOpenModal] = React.useState(false);
    const [isDesktop] = useIsDesktop();

    const handleModalOpen = () => {
        onModalOpen?.();
        setIsOpenModal(true);
    };

    const handleModalClose = () => {
        setIsOpenModal(false);
    };

    return (
        <div className="messageNotComing">
            <Link
                pseudo
                view="default"
                className="messageNotComingLink"
                onClick={handleModalOpen}
            >
                {TITLE}
            </Link>
            <Modal
                isDesktop={isDesktop}
                className="messageNotComingModal"
                title={TITLE}
                open={isOpenModal}
                onClose={handleModalClose}
                content={getContent()}
                actionButton={
                    <Button
                        className="confirm"
                        view="accent"
                        size="s"
                        onClick={handleModalClose}
                        block
                    >
                        Понятно
                    </Button>
                }
            />
        </div>
    );
};
